module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_02.07eddfb4.png";